import { CircularProgress, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useStyles } from "../../styles/SignDialog";
import { useTranslation } from "react-i18next";

export function LoadingDialog() {
  const { t } = useTranslation("global")

  const styles = useStyles();
  const option = false;

  return (
    <>
      {option ? (
        <div className={styles.dialog}>
          <Skeleton className={styles.dialogTitle} variant="text" />
          <Skeleton variant="rect" className={styles.dialogContent} height={300} />
          <div className={styles.dialogSkeleton}>
            <Typography className={styles.loadingText} variant="h6">
              {t("sDialog.loadingTitle")}
            </Typography>
            <Typography className={styles.loadingText} variant="subtitle1">
              {t("sDialog.loadingDescription")}
            </Typography>
          </div>
          <br />
          <Skeleton variant="rect" className={styles.dialogContent} height={100} />
        </div>
      ) : (
        <div className={styles.dialogLoading}>
          <CircularProgress />
          <Typography variant="h6">{t("sDialog.loadingTitle")}</Typography>
          <Typography variant="subtitle1">{t("sDialog.loadingDescription")}</Typography>
        </div>
      )}
    </>
  );
}
